module.exports = __webpack_public_path__ + "img/button_guanbi.3493e721.png";